import { render, staticRenderFns } from "./ReorderImageBlock.vue?vue&type=template&id=4d8c8988&"
import script from "./ReorderImageBlock.vue?vue&type=script&lang=js&"
export * from "./ReorderImageBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports